var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  'v-sidebar_item',
  {
    'v-sidebar_item--active': _vm.active
  }
]},[_c('a',_vm._b({},'a',{ href: _vm.href, target: _vm.target, title: _vm.title },false),[_vm._t("default")],2),(_vm.hasItems && _vm.active)?_c('div',{staticClass:"v-sidebar_item__items"},[_vm._t("items")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }